import React, { useEffect } from 'react'
import styles from './TimeEntryPage.module.css'
import {
    Button,
} from '@material-ui/core'

import axios from "axios";
import LoadingBackdrop from "../../../components/common/LoadingBackdrop";
import {Container, Grid} from "@mui/material";
import Box from "@mui/material/Box";
import TimeClockPage from "./TimeClock/TimeClockPage";
import HistoryPage from "./History/HistoryPage";
import CrewReviewPage from "./CrewReview/CrewReviewPage";
import EmployeeReviewPage from "./EmployeeReview/EmployeeReviewPage";


const TimeEntryPage = (params) => {
    const [loadingBackdrop, setLoadingBackdrop] = React.useState(false)
    const [displayHistory, setDisplayHistory] = React.useState(false)

    const timeClock = () => {
        params.setDisplayTimeEntry(prevState => {return true})
    }

    const crewReview = () => {
        params.setDisplayCrew(prevState => {return true})
    }

    const employeeReview = () => {
        params.setDisplayEmployee(prevState => {return true})
    }

    const historyPage = () => {
        setDisplayHistory(prevState => {return true})
    }

    const [timeData, setTimeData] = React.useState(
        {
            company: '',
            employee: '',
            showbuttonentertime: false,
            showbuttonreviewemployee: false,
            showbuttonreviewcrew: false,
            showbuttonreviewhistory: false,
            showbuttonreviewcreatelme: false,
        })

    useEffect(() => {
        params.setTitle('Time Clock')
        getTimeData()
    }, [])

    useEffect(() => {
        if (displayHistory) {
            setDisplayHistory(false)
            params.setBackArrow('main')
            params.setTitle('Time Clock')
        }
        else if (params.displayTimeEntry) {
            params.setDisplayTimeEntry(false)
            params.setBackArrow('main')
            params.setTitle('Time Clock')
        }
        else if (params.displayCrew) {
            params.setDisplayCrew(false)
            params.setBackArrow('main')
            params.setTitle('Time Clock')
        }
        else if (params.displayEmployee) {
            params.setDisplayEmployee(false)
            params.setBackArrow('main')
            params.setTitle('Time Clock')
        }
    }, [params.backArrowClick])

    const getTimeData = () => {
        var body = {}
        axios.get(`fieldsystemtime`).then((response) => {
            const parsedResponse = JSON.parse(response?.data.jsonString)
            if (parsedResponse?.employee) {
                params.setSubTitle(parsedResponse?.company + ' - ' + parsedResponse?.employee)
            }
            setTimeData(parsedResponse)
            setLoadingBackdrop(false)
        })
    }

    return (
        <div className={styles.root}>
            <LoadingBackdrop open={loadingBackdrop} />
            {/*<div hidden={params.displayFileViewer}>*/}
                <div style={{display: loadingBackdrop ? 'none' : 'inline-flex'}}>
                    <Container>
                        {params.displayTimeEntry &&
                            <TimeClockPage
                                setTitle={params.setTitle}
                                setBackArrow={params.setBackArrow}
                                backArrowClick={params.backArrowClick}
                                displayTimeEntry={params.displayTimeEntry}
                                setDisplayTimeEntry={params.setDisplayTimeEntry}
                                userGuid={params.userGuid}
                            />
                        }
                        {params.displayCrew &&
                            <CrewReviewPage
                                setTitle={params.setTitle}
                                setBackArrow={params.setBackArrow}
                                backArrowClick={params.backArrowClick}
                                displayTimeEntry={params.displayTimeEntry}
                                setDisplayTimeEntry={params.setDisplayTimeEntry}
                                userGuid={params.userGuid}
                            />
                        }
                        {params.displayEmployee &&
                            <EmployeeReviewPage
                                setTitle={params.setTitle}
                                setBackArrow={params.setBackArrow}
                                backArrowClick={params.backArrowClick}
                                displayTimeEntry={params.displayTimeEntry}
                                setDisplayTimeEntry={params.setDisplayTimeEntry}
                                userGuid={params.userGuid}
                            />
                        }
                        {displayHistory &&
                            <HistoryPage
                                setTitle={params.setTitle}
                                setBackArrow={params.setBackArrow}
                                backArrowClick={params.backArrowClick}
                                displayHistory={displayHistory}
                                setDisplayHistory={setDisplayHistory}
                                userGuid={params.userGuid}
                            />
                        }
                        <Box hidden={params.displayCrew || params.displayTimeEntry || params.displayEmployee || displayHistory}>
                            <Grid
                                container
                                border={0}
                                direction="row"
                                alignItems="center"
                                justifyContent="center"
                                height={'100%'}
                                width={'100%'}
                            >
                                <>
                                    {timeData.showbuttonentertime &&
                                        <Grid item border={0} alignItems={'center'} alignContent={'center'} justifyContent="center" md={8} xs={12}>
                                            <Box sx={{
                                                display: 'flex',
                                                flexDirection: { xs: 'column', md: 'row' },
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}
                                            >
                                                <Button onClick={timeClock}
                                                    color="primary" style={{width: '100%', marginTop: '10px'}}  variant="contained">Enter Time</Button>
                                            </Box>
                                        </Grid>
                                    }
                                    {timeData.showbuttonreviewemployee &&
                                        <Grid item border={0} alignItems={'center'} alignContent={'center'} justifyContent="center" md={8} xs={12}>
                                            <Box sx={{
                                                display: 'flex',
                                                flexDirection: { xs: 'column', md: 'row' },
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}
                                            >
                                                <Button
                                                    onClick={employeeReview}
                                                    color="primary" style={{width: '100%', marginTop: '10px'}}  variant="contained">Employee Review</Button>
                                            </Box>
                                        </Grid>
                                    }
                                    {timeData.showbuttonreviewcrew &&
                                        <Grid item border={0} alignItems={'center'} alignContent={'center'} justifyContent="center" md={8} xs={12}>
                                            <Box sx={{
                                                display: 'flex',
                                                flexDirection: { xs: 'column', md: 'row' },
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}
                                            >
                                                <Button onClick={crewReview}
                                                    color="primary" style={{width: '100%', marginTop: '10px'}}  variant="contained">Crew Review</Button>
                                            </Box>
                                        </Grid>
                                    }
                                    {timeData.showbuttonreviewhistory &&
                                        <Grid item border={0} alignItems={'center'} alignContent={'center'} justifyContent="center" md={8} xs={12}>
                                            <Box sx={{
                                                display: 'flex',
                                                flexDirection: { xs: 'column', md: 'row' },
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}
                                            >
                                                <Button onClick={historyPage}
                                                    color="primary" style={{width: '100%', marginTop: '10px'}}  variant="contained">History</Button>
                                            </Box>
                                        </Grid>
                                    }
                                    {timeData.showbuttonreviewcreatelme &&
                                        <Grid item border={0} alignItems={'center'} alignContent={'center'} justifyContent="center" md={8} xs={12}>
                                            <Box sx={{
                                                display: 'flex',
                                                flexDirection: { xs: 'column', md: 'row' },
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}
                                            >
                                                <Button
                                                    color="primary" style={{width: '100%', marginTop: '10px'}}  variant="contained">Create LME</Button>
                                            </Box>
                                        </Grid>
                                    }
                                </>
                            </Grid>
                        </Box>
                    </Container>
                </div>
            {/*</div>*/}
        </div>
    )
}

export default TimeEntryPage